export default {
    close: 'סגור',
    update: 'לעדכן ולסגור',
    save: 'שמור וסגור',
    comment: 'הערה',
    amount: 'סכום',
}
